import React, { Component } from "react";

export default class ProductInfoItem extends Component {
	state = {
		isOpen: false
	};
	handleToggle = () => {
    	this.setState({ isOpen: !this.state.isOpen });
  	};
	render() {
		return (
			<div className={'c-accordion__section__inner ' + (this.state.isOpen ? 'state-open' : "")}>
				<h3 className="c-accordion__header" onClick={this.handleToggle}>{ this.props.info.heading }</h3>
				<div className="c-accordion__body">
					<div className="scope-text" dangerouslySetInnerHTML={ {__html: this.props.info.text} }></div>
				</div>
			</div>
		);
	}  	
}